export default "__VITE_ASSET__CszTAYUP__"